import React from 'react';
import {Button, ButtonVariant, ButtonSize, ButtonType} from '../../../components/button';
import {Heading, Text, TextVariant, TextColor, HeadingLevel} from '../../../components/typography';
import {Modal, ModalSize} from '../../../components/modals/modal';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  email: string;
  company: string;
  portalUrl: string;
  onGoToDashboard: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({isOpen, onClose, name, email, company, portalUrl, onGoToDashboard}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={ModalSize.MD} showCloseButton={false} preventBackdropClose={true}>
      <div className="p-8">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <div className="text-center mb-6">
          <Heading level={HeadingLevel.H3} className="text-gray-900 mb-2">
            Your employer account has been created successfully
          </Heading>
          <Text variant={TextVariant.BODY} color={TextColor.MUTED} className="text-center">
            You&apos;re all set to start discovering and connecting with exceptional talent.
          </Text>
        </div>

        <div className="mb-8">
          <Heading level={HeadingLevel.H4} className="text-gray-900 mb-4 text-center">
            Account details
          </Heading>

          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <Text variant={TextVariant.BODY} color={TextColor.MUTED}>
                Name
              </Text>
              <Text variant={TextVariant.BODY} className="font-medium text-gray-900">
                {name}
              </Text>
            </div>

            <div className="flex justify-between items-center">
              <Text variant={TextVariant.BODY} color={TextColor.MUTED}>
                Email
              </Text>
              <Text variant={TextVariant.BODY} className="font-medium text-gray-900">
                {email}
              </Text>
            </div>

            <div className="flex justify-between items-center">
              <Text variant={TextVariant.BODY} color={TextColor.MUTED}>
                Company
              </Text>
              <Text variant={TextVariant.BODY} className="font-medium text-gray-900">
                {company}
              </Text>
            </div>

            <div className="flex justify-between items-center">
              <Text variant={TextVariant.BODY} color={TextColor.MUTED}>
                Portal URL
              </Text>
              <Text variant={TextVariant.BODY} className="font-medium text-blue-600">
                {portalUrl}
              </Text>
            </div>
          </div>
        </div>

        <Button type={ButtonType.BUTTON} variant={ButtonVariant.Primary} size={ButtonSize.MD} fullWidth onClick={onGoToDashboard}>
          Go to Dashboard
        </Button>
      </div>
    </Modal>
  );
};
